import { IApiBaseErrorResponse } from '@app/api/interfaces/api-base-error-response.interface';
import { IComment } from '@app/api/interfaces/comment.interface';
import { IFpLoggerNoiseData } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/interfaces/fp-logger-noise-data';

export enum FpLoggerNoiseCommentsActionType {
  GetData = 'GetData',
  GetDataSuccesses = 'GetDataSuccesses',
  UpdateComment = 'UpdateComment',
  UpdateCommentSuccess = 'UpdateCommentSuccess',
  UpdateCommentError = 'UpdateCommentError',
}

export interface FpLoggerNoiseCommentsActionGetData {
  type: FpLoggerNoiseCommentsActionType.GetData;
  date: string | null;
  popupMainData: IFpLoggerNoiseData | null;
}

export interface FpLoggerNoiseCommentsActionGetDataSuccesses {
  type: FpLoggerNoiseCommentsActionType.GetDataSuccesses;
  date: string | null;
  data: IFpLoggerNoiseData | null;
}

export interface FpLoggerNoiseCommentsActionUpdateComment {
  type: FpLoggerNoiseCommentsActionType.UpdateComment;
  content: string;
}

export interface FpLoggerNoiseCommentsActionUpdateCommentSuccess {
  type: FpLoggerNoiseCommentsActionType.UpdateCommentSuccess;
  comment: IComment;
}

export interface FpLoggerNoiseCommentsActionUpdateCommentError {
  type: FpLoggerNoiseCommentsActionType.UpdateCommentError;
  error: IApiBaseErrorResponse;
}

export type FpLoggerNoiseCommentsActions =
  | FpLoggerNoiseCommentsActionGetData
  | FpLoggerNoiseCommentsActionGetDataSuccesses
  | FpLoggerNoiseCommentsActionUpdateComment
  | FpLoggerNoiseCommentsActionUpdateCommentSuccess
  | FpLoggerNoiseCommentsActionUpdateCommentError;
